import React, {useMemo, useState} from 'react';
import {useTranslation} from "react-i18next";
import Currency from "../../Utils/Number/Currency";
import Alert from "../../UI/Alerts/Alert";

import Creditcards from "../../Utils/Creditcards/Creditcards";
import CardsList from "../../Profile/SavedPaymentMethods/Cards/List";
import Banks from "../../Utils/Banks/Banks";
import BanksList from "../../Profile/SavedPaymentMethods/Banks/List";
import BasicDataTable from "../../Utils/BasicDataTable";
import DateFormated from "../../Utils/Date/Date";
import UserContext from '../../../context/user-context';
import CardPayForm from "../../Profile/SavedPaymentMethods/Cards/Forms/Pay";
import BankPayForm from "../../Profile/SavedPaymentMethods/Banks/Forms/Pay";

const PaymentPopupV2 = (props) => {
    const {t, i18n} = useTranslation();
    const [paymentMode, setPaymentMode] = useState(null);
    const [cardUsed, setCardUsed] = useState(false);
    const [bankUsed, setBankUsed] = useState(false);
    const [confirmationNumber, setConfirmationNumber] = useState(false);
    const [alert, setAlert] = useState({});
    const userContext = React.useContext(UserContext);
    const user = userContext.user;
    const isLimitedUser = user && user.infos && user.infos.permission === 'limited';

    const resetMessages = () => {
        setAlert({});
        setConfirmationNumber(false);
    }
    const handleShowMessage = (type, message) => {
        resetMessages();

        $('.modal-body').animate({scrollTop: 0});

        if (type === 'error')
            setAlert({type: 'danger', item: {type: 'top', text: message}});
        else if (type === 'warning')
            setAlert({type: 'warning', item: {type: 'top', text: message}});
        else if (type === 'success')
            setAlert({type: 'success', item: {type: 'top', text: message}});
        else if (type === 'confirmation')
            setConfirmationNumber(message);
    }


    const generateTable = (invoices, insub) => {

        const columns = useMemo(
            () => [
                {
                    Header: t("docs.invoices.table.headers.invoice_no"),
                    accessor: "invoiceNumber",
                    Cell: (props) => {
                        if (props.value) return props.value;
                        else return "";
                    },
                },
                {
                    Header: t("docs.invoices.table.headers.amount"),
                    accessor: "balanceAmount",
                    Cell: (props) => {
							return <React.Fragment>
								<span className="amount-price">
									{props.value ? <Currency value={props.value.value}/> : ""}
								</span>
								<strong className="span--c-red">
									<Currency value={-(props.row.original.paidAmount)}/>
								</strong><br/>
							</React.Fragment>
                    },
                },
				{
					Header: t('docs.invoices.table.headers.balance'),
					accessor: "balanceAmount.value",
					show: false,
					Cell: (props) => {
						return (
							<span className="amount-price">
								{props.value ? <Currency value={props.value-props.row.original.paidAmount}/> : ""}
							</span>)
					},
				},
				{
					Header: t('docs.invoices.table.headers.subaccount'),
					accessor: "subAccountCode",
					show: false,
					Cell: (props) => {
						return (props.value) ? props.value : '';
					},
				}
            ],
            [t, i18n, invoices]
        );

        return <div id="table-payment-resume">
            <BasicDataTable columns={columns} data={invoices} classes={'test'}/>
        </div>
    }

    const paymentDone = confirmationNumber && (cardUsed || bankUsed)

    let canPayCredit = true;
    let canPayEFT = true;

    let maxCredit = [];
    let maxEFT = [];
    let minCredit = [];
    let minEFT = [];

    if (props.subAccounts) {
        props.theSelection.map((item) => {
            let sub = props.subAccounts.find((sub) => sub.subAccountCode === item.subAccountCode);
            maxCredit.push(sub.maximumOnlinePaymentCreditCard)
            maxEFT.push(sub.maximumOnlinePaymentEFT)
            minCredit.push(sub.minimumOnlinePaymentCreditCard)
            minEFT.push(sub.minimumOnlinePaymentEFT)

            if (!sub.isOnlinePaymentCreditCardAllowed)
                canPayCredit = false;
            if (!sub.isOnlinePaymentEFTAllowed)
                canPayEFT = false;
        });

        maxCredit = Math.min(...maxCredit);
        maxEFT = Math.min(...maxEFT);
        minCredit = Math.min(...minCredit);
        minEFT = Math.min(...minEFT);

        if (props.amount > maxCredit || props.amount < minCredit) {
            canPayCredit = false;
        }

        if (props.amount > maxEFT || props.amount < minEFT) {
            canPayEFT = false;
        }
    }
    else{
        canPayCredit = false;
        canPayEFT = false;
    }

	// DO NOT PR WITH THIS LINE ACTIVATED
    // canPayCredit = true;

    if(paymentDone){
        document.querySelector(".modal-header h3").innerHTML = t('popup.confirmation');
    }
    return (
        <React.Fragment>

            {(paymentDone ?
                <div className="row row--rmline">
                    <div id="payment-success" className="message message--success">
                        <div className="message__icon">
                            <i className="fas fa-check-circle"></i>
                        </div>
                        <div className="message__content">
                            <div>
                                <span>{t('payment.success_message.line1')}</span>
                                <span
                                    className="p--c-black">{' '}{t('payment.success_message.line2', {confirmation_number: confirmationNumber})}</span>
                                <br/>
                                <span className="p--c-black">{t('payment.success_message.line3')}</span>
                                {
                                    paymentMode === 'bank' &&
                                    <>
                                        <br/>
                                        <span className="p--c-black">{t('payment.success_message.delaybank')}</span>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div> : null)}

            {(alert != {} ? <div>
                    <div className={"messages"}>
                        <Alert type={alert.type} item={alert.item}/>
                    </div>
                </div>
                : null)}

            <div className="row row--rmline">
                <div className="col-sm-6 mb-3">
                    <p>
                        <strong>{props.userAccount.name}</strong><br/>
                        {(props.userAccount.address.addressLine1) &&
                        <span>{props.userAccount.address.addressLine1}<br/></span>}
                        {(props.userAccount.address.addressLine2) &&
                        <span>{props.userAccount.address.addressLine2}<br/></span>}
                        {(props.userAccount.address.city) && <span>{props.userAccount.address.city}</span>}
                        {(props.userAccount.address.stateOrProvinceCode) &&
                        <span>,&nbsp;{props.userAccount.address.stateOrProvinceCode}<br/></span>}
                        {props.userAccount.address.postalCode}
                    </p>

                </div>
                <div className="col-sm-6 mb-3 d-flex justify-content-end">
                    <p className="">
                        {!paymentDone ? t("payment.popup.amounttopay") : t("payment.popup.amountpaid")}<br/>
                        <span className="price">
                            <Currency
                                value={props.amount}/>
                            </span>
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <strong
                        className="d-block mb-2">{t(`payment.popup.resume.default`)} {props.theSelection ? `(${props.theSelection.length})` : ''}</strong>
                    {props.theSelection && <React.Fragment>
                        {generateTable(props.theSelection, false)}
                    </React.Fragment>}
                </div>
            </div>
            {!paymentDone && <div className="payment-selector d-flex flex-wrap mb-4 mt-2 mt-sm-3">

                {canPayEFT && <button
                    className={`btn btn--outline btn--larger mb-2 mr-0 mr-sm-4 ${paymentMode === 'bank' && 'active'}`}
                    onClick={() => setPaymentMode('bank')}>
                    {t("payment.popup.paybybank")}
                </button>}

                {canPayCredit && <button
                    className={`btn btn--outline btn--larger mb-2 mr-0 mr-sm-4 ${paymentMode === 'credit' && 'active'}`}
                    onClick={() => setPaymentMode('credit')}>
                    {t("payment.popup.paybycredit")}
                </button>}
            </div>}
            {
                !paymentDone && paymentMode === 'bank' && <React.Fragment>
                    {!isLimitedUser ? (
                        <BanksList
                            from={'popup'}
                            can={{select: true, delete: true, pay: true}}
                            amount={props.amount}
                            sub_account={props.userAccount}
                            invoices={props.theSelection}
                            paymentOption={props.type}
                            handleShowMessage={handleShowMessage}
                            resetMessages={resetMessages}
                            setBankUsed={setBankUsed}/>
                    ) : (
                        <BankPayForm
                            amount={props.amount}
                            invoices={props.theSelection}
                            paymentOption={props.type}
                            handleShowMessage={handleShowMessage}
                            resetMessages={resetMessages}
                            setBankUsed={setBankUsed}
                            save={false}
                        />
                    )}
                </React.Fragment>
            }
            {
                !paymentDone && paymentMode === 'credit' && <React.Fragment>
                    {!isLimitedUser ? (
                        <CardsList
                            from={'popup'}
                            can={{select: true, delete: true, pay: true}}
                            amount={props.amount}
                            sub_account={props.userAccount}
                            invoices={props.theSelection}
                            paymentOption={props.type}
                            handleShowMessage={handleShowMessage}
                            resetMessages={resetMessages}
                            setCardUsed={setCardUsed}/>
                    ) : (
                        <CardPayForm
                            amount={props.amount}
                            invoices={props.theSelection}
                            paymentOption={props.type}
                            handleResponse={handleShowMessage}
                            resetMessages={resetMessages}
                            setCardUsed={setCardUsed}
                            save={false}
                        />
                    )}
                </React.Fragment>
            }

            {(paymentDone ?
                <React.Fragment>
                    <div className="row row--bordered">
                        <div className="col-sm-6">
                            {t("popup.modeofpayment")}<br/>
                            {paymentMode === 'credit' ? <strong>
                                <Creditcards type={cardUsed.card_type}/>{' '}{t('payment.card_resume', {
                                type: t('payment.card_type.' + cardUsed.card_type),
                                last4digits: cardUsed.card_ending
                            })}</strong> : <strong>
                                {t('payment.card_resume', {
                                    type: bankUsed.institution,
                                    last4digits: bankUsed.bank_account_ending
                                })}</strong>}

                        </div>
                        <div className="col-sm-6">
                            {t("popup.dateofpayment")}<br/>
                            <strong><DateFormated date={Date.now()}/></strong>
                        </div>
                    </div>
                    {/*<div className="row">
                        <div className="col-sm-12 d-flex justify-content-end">
                            <button className="btn btn--raised btn--raised--red btn--fs-12" style={{width: "164px"}}
                                    onClick={props.modalActionClose}>{t("popup.close")}</button>
                        </div>
                    </div>*/}
                </React.Fragment> : null)}

        </React.Fragment>
    )
}

export default PaymentPopupV2;
